import React, {useEffect, useRef, useState} from 'react';
import './ChatsList.scss'
import {getHeaderHeight} from "../../../../utils/helperFunctions";
import {EditBoxIcon, PlusNewIcon, SearchIcon} from "../../../../image";
import {useTranslation} from "react-i18next";
import {Form} from "react-bootstrap";
import {useLocation} from "react-router-dom";
import {Tooltip} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {
    CreateChatSessionService, DeleteChatSessionService,
    GetChatSessionsService, UpdateChatSessionService, UpdateGlobalChatService,
    UpdateSelectedIdSessionService
} from "../../../../redux/actions/chatActions";
import {Button} from "../../../../modules/Button";
import ChatListTopPanel from "../ChatListTopPanel/ChatListTopPanel";
import {FILTERS, groupByAgentId} from "../../helpers";
import SessionItemBlock from "../SessionItemBlock/SessionItemBlock";
import {GetAgentsService} from "../../../../redux/actions";


const ChatsList = () => {
    const {t, i18n} = useTranslation();
    const location = useLocation();
    const [searchText, setSearchText] = useState('');
    const [isGlobal, setIsGlobal] = useState(false);
    const isCheckVideoPage = (location.pathname || '').includes('/dashboard/videos/video');
    const videoInfo = useSelector(state => state.videos.videoById);
    const sessionsInfo = useSelector(state => state.chat.sessionsInfo || []);
    const selectedIdSession = useSelector(state => state.chat.selectedIdSession);
    const isGlobalChat = useSelector(state => state.chat.isGlobalChat);
    const dispatch = useDispatch();
    const listRef = useRef(null);
    const [editSessionId, setEditSessionId] = useState(false);
    const inputRef = useRef(null);
    const [changeName, setChangeName] = useState('');
    const idRef = useRef(null);
    const [open, setOpen] = useState(true);
    const [activeTab, setActiveTab] = React.useState(FILTERS.ALL);
    const isAiAgents = (location.pathname || '').includes('/copilot');
    const SUB_HEADER_HEIGHT = isAiAgents ? 73 : 120;

    useEffect(()=>{
        idRef.current = editSessionId
    },[editSessionId])

    const updateSession = async () => {
        try {
            if(idRef.current){
                await UpdateChatSessionService(idRef.current, {summary: inputRef.current?.value});
                setChangeName('');
                setEditSessionId(null);
                setOpen(false);
            }
        }catch (e) {
            console.log('EER',e)
        }
    }
    const deleteSession = async (id) => {
        try {
            await DeleteChatSessionService(id);
            dispatch(UpdateSelectedIdSessionService(sessionsInfo?.[0]?.id));
            setOpen(false);
        }catch (e) {
            console.log('Error',e)
        }
    }

    useEffect(() => {
        const handleClick = async (event) => {
            if (inputRef.current && inputRef.current.contains(event.target)) {
                console.log('Клик ВНУТРИ input');
            } else {
                try{
                    updateSession();
                }catch (e) {
                    console.error(e)
                }
            }
        };

        document.addEventListener('click', handleClick);
        dispatch(GetAgentsService());

        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);

    useEffect(() => {
        scrollToItem(selectedIdSession)
    }, [selectedIdSession]);

    const scrollToItem = (id) => {
        console.log('ID', id)
        const findAgentId = sessionsInfo?.find((session) => session?.id === selectedIdSession)?.agent_id;
        const targetElement = listRef?.current?.querySelector(`#session-item-${id}`);
        console.log('targetElement', targetElement?.current)
        if (targetElement && listRef.current) {
            listRef.current.scrollTo({
                top: targetElement.offsetTop - listRef.current.offsetTop - (findAgentId ? 80: 50),
                behavior: 'smooth',
            });
        }
    };

    const createNewSession = async () => {
        try {
            const data = await CreateChatSessionService((isGlobalChat || !videoInfo?.id) ? {} : {video_id: videoInfo?.id});
            dispatch(UpdateSelectedIdSessionService(data?.id));
            if (!data?.is_read) UpdateChatSessionService(data?.id, {is_read: true});
            listRef.current.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        } catch (e) {
            console.error(e)
        }
    }

    const updateGlobalChat = async (value) => {
        try {
            dispatch(UpdateGlobalChatService(value));
            const response = await dispatch(GetChatSessionsService({
                video_id: value ? undefined : videoInfo?.id
            }));
            dispatch(UpdateSelectedIdSessionService(response?.[0]?.id));
            if (!response?.[0]?.is_read) UpdateChatSessionService(response?.[0]?.id, {is_read: true});
        } catch (e) {
            console.error(e)
        }
    }

    const onHandleClickSession = async (value) => {
        try {
            scrollToItem(value?.id);
            dispatch(UpdateSelectedIdSessionService(value?.id));

            if (!value?.is_read) {
                UpdateChatSessionService(value?.id, {is_read: true});
            }
        } catch (e) {
            console.error(e)
        }
    }

    function handleOpenChange(newOpen, id) {
        setOpen(newOpen ? id : null);
    }

    const handleKeyDown = async (event) => {
        if (event.key === "Enter") {
            updateSession();
        }
    };

    return (
        <div className="chats-list" onWheel={(e) => e.stopPropagation()}>
            <div className="chats-list__header">
                <div className="chats-list__search" tabIndex={0}>
                    <div className="chats-list__search-wrap">
                        <SearchIcon/>
                        <input
                            className="chats-list__search-input"
                            value={searchText}
                            onChange={(e) => setSearchText(e?.target?.value || '')}
                            type="text"
                            placeholder={t('input_search')}
                        />
                    </div>
                </div>
                {isAiAgents
                    ? null
                    :
                    <>
                    <Form.Check
                        type="switch"
                        className="chats-list__header--switcher"
                        checked={isGlobalChat}
                        onChange={(e) => updateGlobalChat(e?.target.checked)}
                        disabled={!isCheckVideoPage}
                        label={t('this_global')}
                    />
                    <Tooltip
                        placement="bottom"
                        title={t('chat_clean_btn')}
                    >
                        <EditBoxIcon
                            className={`chats-list__header--edit-icon ${sessionsInfo?.length && !sessionsInfo?.[0]?.summary ? 'chats-list__header--disabled' : ''}`}
                            onClick={() => sessionsInfo?.length && !sessionsInfo?.[0]?.summary ? null : createNewSession()}
                        />
                    </Tooltip>
                </>
            }
            </div>
            <div
                style={{height: `calc(100vh - ${getHeaderHeight() + SUB_HEADER_HEIGHT}px`}}
                className="chats-list__container custom-scroll"
                ref={listRef}
                onWheel={(e) => e.stopPropagation()}
            >
                <ChatListTopPanel activeTab={activeTab} setActiveTab={setActiveTab}/>
                {!sessionsInfo?.length ?
                    <Button
                        size="xs"
                        variant="ghost" leftIcon={<PlusNewIcon/>} text="Start a new chat"
                        className="chats-list__new-chat"
                        onClick={createNewSession}
                    /> : null}
                <div className="chats-list__feed">
                        {groupByAgentId(sessionsInfo.filter((session) => activeTab === FILTERS.ALL ? true : !session.is_read))
                            .filter((item) => (item?.summary || '').toLowerCase().includes(searchText.toLowerCase()))
                            .map((session)=>(
                        <SessionItemBlock
                            data={session}
                            editSessionId={editSessionId}
                            changeName={changeName}
                            setChangeName={setChangeName}
                            onHandleClickSession={onHandleClickSession}
                            inputRef={inputRef}
                            setEditSessionId={setEditSessionId}
                            open={open}
                            handleKeyDown={handleKeyDown}
                            deleteSession={deleteSession}
                            handleOpenChange={handleOpenChange}
                        />
                    ))}
                    {/*{(sessionsInfo || []).filter((item) => (item?.summary || '').toLowerCase().includes(searchText.toLowerCase())).map((item) => (*/}
                    {/*    <>*/}
                    {/*        {editSessionId === item?.id ?*/}
                    {/*            <input*/}
                    {/*                ref={inputRef}*/}
                    {/*                className="chats-list__feed--item-input"*/}
                    {/*                onChange={(e) => setChangeName(e?.target?.value || '')}*/}
                    {/*                value={changeName}*/}
                    {/*                onKeyDown={handleKeyDown}*/}
                    {/*            />*/}
                    {/*            :*/}
                    {/*            <div*/}
                    {/*                className={`chats-list__feed--item ${selectedIdSession === item?.id ? 'chats-list__feed--item-active' : ''}`}*/}
                    {/*                onClick={() => onHandleClickSession(item)}*/}
                    {/*                id={`session-item-${item?.id}`}*/}
                    {/*            >*/}
                    {/*                <Text*/}
                    {/*                    size="f14"*/}
                    {/*                    font={selectedIdSession === item?.id ? 'liteMedium' : 'book'}*/}
                    {/*                    color={selectedIdSession === item?.id ? 'black' : '#4A4A4A'}*/}
                    {/*                    className="chats-list__feed--item-text"*/}
                    {/*                >*/}
                    {/*                    {item.summary || 'New chat'}*/}
                    {/*                </Text>*/}
                    {/*                {!item?.is_read ? <div className="chats-list__feed--item-badge"/> : null}*/}
                    {/*                <Popover*/}
                    {/*                    arrow={false}*/}
                    {/*                    trigger='hover'*/}
                    {/*                    placement="bottomLeft"*/}
                    {/*                    open={open === item?.id}*/}
                    {/*                    overlayClassName='popover_edit-menu'*/}
                    {/*                    onOpenChange={(e)=>handleOpenChange(e,item?.id)}*/}
                    {/*                    getPopupContainer={() => document.getElementById(`session-item-${item?.id}`)}*/}
                    {/*                    content={*/}
                    {/*                        <>*/}
                    {/*                            <div*/}
                    {/*                                className={'popover_edit-menu--item'}*/}
                    {/*                                onClick={(e) => {*/}
                    {/*                                    e.stopPropagation();*/}
                    {/*                                    setEditSessionId(item?.id);*/}
                    {/*                                    setChangeName(item?.summary)*/}
                    {/*                                }}*/}
                    {/*                            >*/}
                    {/*                                <EditIcon className={''}/> {t('button_edit')}*/}
                    {/*                            </div>*/}
                    {/*                            <div*/}
                    {/*                                className={'popover_edit-menu--item delete'}*/}
                    {/*                                onClick={(e) => {*/}
                    {/*                                    deleteSession(item?.id)*/}
                    {/*                                }}*/}
                    {/*                            >*/}
                    {/*                                <DeletingIcon className={''}/> {t('button_delete')}*/}
                    {/*                            </div>*/}
                    {/*                        </>*/}
                    {/*                    }*/}
                    {/*                >*/}
                    {/*                    <div className="popover_edit-menu--settings"*/}
                    {/*                         onClick={(e) => e.stopPropagation()}>*/}
                    {/*                        <EllipsisIcon/>*/}
                    {/*                    </div>*/}
                    {/*                </Popover>*/}
                    {/*            </div>*/}
                    {/*        }*/}
                    {/*    </>*/}
                    {/*))}*/}
                </div>
            </div>
        </div>
    );
};

export default ChatsList;